import { UliItemActionParams, UliItemGetCarriersParams, UliItemUliInfo } from '../../models/uli-item-overview.model';
import { UliItemOverviewTruckInfoUpdateModel } from '../../models';
import { UliItemOverviewMainInfoUpdateModel } from '../../models/uli-main-info-update.model';
import { UliActivityType } from '../../../../../../../common/constants/uli';

export class UliItemOverviewLoad {
  public static readonly type = '[UliItemOverview] Load';

  constructor(public payload: UliItemActionParams) {}
}

export class UliItemOverviewStatusesLoad {
  public static readonly type = '[UliItemOverview] Statuses Load';

  constructor(public payload: UliItemActionParams) {}
}

export class UliItemOverviewUpdate {
  public static readonly type = '[UliItemOverview] Update Uli Overview';

  constructor(
    public payload: {
      uliItemActionParams: UliItemActionParams;
      uliItem: UliItemUliInfo;
    },
  ) {}
}

export class UliItemOverviewUpdateTruckDetails {
  public static readonly type = '[UliItemOverview] Update Truck Details';

  constructor(
    public payload: {
      compartmentId: number;
      type: UliActivityType;
      uli: string;
      oldTruckId: number;
      toUpdate: UliItemOverviewTruckInfoUpdateModel;
    },
  ) {}
}

export class UliItemOverviewUpdateMainInfoDetails {
  public static readonly type = '[UliItemOverview] Update Main Info Details';

  constructor(
    public payload: {
      compartmentId: number;
      toUpdate: UliItemOverviewMainInfoUpdateModel;
      type: UliActivityType;
      uliNumber: string;
      callback: () => void;
    },
  ) {}
}

export class UliItemOverviewDeleteParkingSpot {
  public static readonly type = '[UliItemOverview] Delete Parking Spot';

  constructor(public payload: { truckId: number; hubId: number }) {}
}

export class UliItemOverviewUpdateParkingSpot {
  public static readonly type = '[UliItemOverview] Update Parking Spot';

  constructor(public payload: { truckId: number; hubId: number; parkingSpaceId: string }) {}
}

export class UliItemOverviewSapNotify {
  public static readonly type = '[UliItemOverview] Uli SAP Notify';

  constructor(public payload: UliItemActionParams) {}
}

export class UliItemOverviewCarriersLoad {
  public static readonly type = '[UliItemOverview] Carriers Load';

  constructor(public payload: UliItemGetCarriersParams) {}
}

export class UliItemOverviewInitialState {
  public static readonly type = '[UliItemOverview] Set Initial State';
}
